import * as yup from "yup";
import { Schema } from "../../schema";
import { SingleValueObject } from "../base-value-object";
export class PostalCode extends SingleValueObject {
    postalCode;
    constructor(value) {
        super(value);
        this.postalCode = value.postalCode;
    }
    validator(value) {
        return this.validate(value, PostalCode.schema);
    }
    equals(t) {
        return this.toString() === t?.toString();
    }
    getValue() {
        return this.postalCode;
    }
    toString() {
        return this.postalCode;
    }
    static schema(required = true) {
        return Schema.required({
            postalCode: yup
                .string()
                .matches(/^[0-9]{3}-[0-9]{4}$/)
                .label("郵便番号"),
        }, required);
    }
}
//# sourceMappingURL=postal-code.js.map